import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchEmployeeDetailsApi, submitEmployeeDetailsApi, updateEmployeeFieldApi } from "../../api/employee.api";
import toast from "react-hot-toast";

interface EmployeeState {
  loading: boolean;
  success: boolean;
  error: string | null;
  userDetails: Record<string, any> | null;
}

const initialState: EmployeeState = {
  loading: false,
  success: false,
  error: null,
  userDetails: null,
};

export const submitEmployeeDetails = createAsyncThunk(
  "employee/submitDetails",
  async (payload: any, { rejectWithValue }) => {
    try {
      return await submitEmployeeDetailsApi(payload); 
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchEmployeeDetails = createAsyncThunk(
  "employee/fetchDetails",
  async (userId: string, { rejectWithValue }) => {
    try {
      return await fetchEmployeeDetailsApi(userId);
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to fetch details");
    }
  }
);

export const updateEmployeeField = createAsyncThunk(
  "employee/updateField",
  async (
    { userId, fieldKey, value }: { userId: string; fieldKey: string; value: any },
    { rejectWithValue }
  ) => {
    try {
      return await updateEmployeeFieldApi({ userId, fieldKey, value });
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to update field");
    }
  }
);


const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    resetEmployeeState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      
    },
  },
  extraReducers: (builder) => {
    builder
          .addCase(fetchEmployeeDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = action.payload;  
      })
      .addCase(fetchEmployeeDetails.rejected, (state) => {
        state.loading = false;
      })
      .addCase(submitEmployeeDetails.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(submitEmployeeDetails.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(submitEmployeeDetails.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      })
       .addCase(updateEmployeeField.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateEmployeeField.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;

        // Optimistically update the local state
        const { fieldKey, value } = action.payload;
        if (state.userDetails) {
          state.userDetails[fieldKey] = value;
        }
      })
      .addCase(updateEmployeeField.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });;
  },
});

export const { resetEmployeeState } = employeeSlice.actions;
export default employeeSlice.reducer;
